import { useEffect, useState } from "react";
import { api, fileUrl } from "@/lib/api";
import { ImageIcon } from "lucide-react";

export function AuthImage({ fileId, alt = "", className = "", fallbackClassName = "" }) {
  const [src, setSrc] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    let objectUrl;
    let cancelled = false;
    if (!fileId) { setSrc(null); return; }
    setErr(false);
    (async () => {
      try {
        const res = await api.get(`/files/${fileId}`, { responseType: "blob" });
        if (cancelled) return;
        objectUrl = URL.createObjectURL(res.data);
        setSrc(objectUrl);
      } catch (e) {
        if (!cancelled) {
          console.warn("AuthImage load failed:", e?.message || e);
          setErr(true);
        }
      }
    })();
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [fileId]);

  if (!fileId || err) {
    return (
      <div
        data-testid="image-placeholder"
        className={`flex items-center justify-center bg-muted text-muted-foreground ${fallbackClassName || className}`}
      >
        <ImageIcon className="w-6 h-6 opacity-60" />
      </div>
    );
  }
  if (!src) return <div className={`bg-muted animate-pulse ${className}`} />;
  return <img src={src} alt={alt} className={className} data-testid="auth-image" />;
}
